export const APP_MUTATIONS = {
  TOGGLE_DEVICE: 'TOGGLE_DEVICE'
}
